import { useMsal } from '@azure/msal-react'
import Cookies from 'js-cookie'
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import moment from 'moment';

// Safe client-side JWT payload decoding without signature verification
const decodeJWTPayload = (token) => {
  try {
    if (!token) return null;
    const payload = token.split('.')[1];
    if (!payload) return null;
    const decodedPayload = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decodedPayload);
  } catch (error) {
    console.error('Error decoding JWT payload:', error);
    return null;
  }
};

const COOKIE_NAME = 'accessToken'

export const useMsalSessionManagement = () => {
  const pathname = useLocation().pathname;
  const { getToken } = useAuth()

  useEffect(() => {
    getToken();
    const accessToken = Cookies.get(COOKIE_NAME);
      if (accessToken) {
        const payload = decodeJWTPayload(accessToken);
        if (payload && payload.exp) {
          let time1 = moment.utc(moment.utc(new Date((payload.exp * 1000)).toISOString()), "hh:mm:ss");
          let time2 = moment.utc(moment.utc(new Date().toISOString()), "hh:mm:ss");
              let subtract = time1.diff(time2);
             
          let interval;
          if (subtract > 0) {
              interval = setInterval(getToken, subtract + 1000);
          }
          return () => clearInterval(interval);
        }
    }
  }, [pathname]);
};

export const useAuth = () => {
    const { instance, accounts } = useMsal();

    const login = async () => {
        return await instance.loginRedirect({
            scopes: ["api://ent-cust-search-api.lilly.com/.default"],
            redirectUri: window.location.origin
        })
    }

    const logout = () => {
        Cookies.remove(COOKIE_NAME)
        instance.logoutRedirect()
    }

    const isTokenExpired = () => {
        const accessToken = Cookies.get(COOKIE_NAME)
        if (!accessToken) return true;
        
        const payload = decodeJWTPayload(accessToken);
        if (!payload || !payload.exp) return true;
        
        const expiryTime = new Date(payload.exp * 1000).getTime()
        return new Date().getTime() > expiryTime
    }

    const getToken = async () => {
        const cachedToken = Cookies.get(COOKIE_NAME)
        if (cachedToken && !isTokenExpired())
            return cachedToken;

        if (accounts.length > 0) {
            try {
                const response = await instance.acquireTokenSilent({
                    scopes: ["api://ent-cust-search-api.lilly.com/.default"],
                    account: accounts[0],
                    forceRefresh: true
                })

                await Cookies.set(COOKIE_NAME, response.accessToken)
                return response.accessToken;
            }
            catch (error) {
                console.log("Acquire Silent Token Failed! Redirecting to Login...", error);
                await login()
            }
        } else await login();
    }

    return { login, logout, getToken }
}